export const LANGUAGE = {
  ENGLISH: 'English',
  THAI: 'Thai',
};

export const LANGUAGE_TRANSLATION = {
  ENGLISH: 'en',
  THAI: 'th',
};
